import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logIn } from "store/slices/authPages";
import Login from "components/auth/Login";

export default function LoginPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const redirectUrl = query.get("redirectUrl");
  const [showNotification, setShowNotification] = useState({ type: "", message: "" });

  async function handleSubmit(data) {
    setShowNotification(false);
    try {
      const result = await dispatch(logIn(data.email, data.password, redirectUrl));
      localStorage.clear();
      if (result.success) {
        setShowNotification({ type: "success", message: result.message });
      } else {
        setShowNotification({ type: "error", message: result.message });
      }
    } catch (error) {}
  }

  async function handleForgot() {
    navigate("/forgot-password");
  }

  async function handleSignUp(e) {
    e.preventDefault();
    navigate("/sign-up");
  }

  function handleAlertClose() {
    setShowNotification({ type: "", message: "" });
  }

  return (
    <>
      <Login
        onSubmit={handleSubmit}
        onForgot={handleForgot}
        onSignup={handleSignUp}
        onAlertClose={handleAlertClose}
        showNotification={showNotification}
      />
    </>
  );
}
